import React from "react";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import FriendGroupChildrenToggle from "components/Tribe/FriendGroupChildrenToggle";
import ManageChildrenRequests from "./ManageChildrenRequests";
import * as CONSTANT from "constants/text";
import "containers/Tribe/Friends/Home/MyFriends.css";

class ManageChildTribeHome extends React.Component {
  render() {
    /*use the same layout as MyFriends.js*/
    return (
      <div className="header_main">
        <div className="page_main">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="page_details_main tribe">
            <div className="mb-15 friend_group_button">
              <FriendGroupChildrenToggle activeTab={CONSTANT.CHILDREN} />
            </div>
            <div className="page_details_content_main">
              <div className="mb-15 textHeader">{CONSTANT.MANAGE_CHILD_TRIBE}</div>
              <ManageChildrenRequests history={this.props.history} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ManageChildTribeHome;
